import { Component, OnInit, Input } from '@angular/core';
import { SessionState } from 'aws-sdk/clients/appstream';
import { SessionStateService } from '../../../../core/services/session-state.service';
import { HOUSE_TARIFF } from '../../../../entities/houses/houses.constants';
import { Route } from '@angular/compiler/src/core';
import { ActivatedRoute, Params } from '@angular/router';
import { DevicesService } from '../../../../entities/devices/devices.service';
import { Device } from '../../../../entities/devices/devices.model_new';
import { GROUP } from '../../../../entities/devices/devices.constant';
import { HOUSE_COUNTRIES } from '../../../../entities/houses/houses.constants';

@Component({
  selector: 'app-coachmark-device-detail',
  templateUrl: './coachmark-device-detail.component.html',
  styleUrls: ['./coachmark-device-detail.component.scss']
})
export class CoachmarkDeviceDetailComponent implements OnInit {
  show: boolean;
  selectedTab: number;
  economicExcluded: boolean;
  moduleId: any;
  device: Device;
  constructor(private sessionStateService: SessionStateService,
              private route: ActivatedRoute,
              private devicesService: DevicesService) { }

  ngOnInit() {
    this.route.params
    .subscribe(
      (params: Params) => {
        this.moduleId = params['moduleId'];
        this.getDevice().subscribe();
      });

    const waitloadDevice = setInterval(() => {
      this.checkEconomicExclusion();
     if (this.hasScheduling() && !this.isThermo()) {
      this.selectedTab = 1;
      this.loadNewSchedule();
      this.show = true;
     } if (this.isAC()) {
       this.loadScheduling();
       this.show = true;
     }
     clearInterval(waitloadDevice);
    }, 2000);

  }

  getDevice() {
    return this.devicesService.getHouseModule(this.sessionStateService.getHouse().houseId, this.moduleId)
    .map(res => {
      if (res.getModuleId()) {
        this.device = res;
        const groups: Set<GROUP> = this.device.getGroups();
      }
    });
  }

  skipHelpTips() {
    this.show = false;
    this.sessionStateService.setCoachMarkIndividualState(this.sessionStateService.getCoachMarkIndividualState().set('device-detail', false));
  }

  checkEconomicExclusion() {
    if (this.sessionStateService.getHouseTariff().tariff === HOUSE_TARIFF.SIMPLE
    || (this.sessionStateService.getHouse().country === HOUSE_COUNTRIES.SPAIN)) {
      this.economicExcluded = true;
    } else {
      this.economicExcluded = false;
    }
  }

  nextTab() {
    if (this.selectedTab === 1) {
      this.selectedTab++;
      this.loadOnOff();
    } else if (this.selectedTab === 2) {
      this.selectedTab++;
      if (!this.economicExcluded) {
        this.loadEconomic();
      } else {
        this.loadStandByKiller();
      }
    } else if (this.selectedTab === 3) {
      if (!this.economicExcluded) {
        this.loadStandByKiller();
        this.selectedTab++;
      } else {
        this.skipHelpTips();
      }
    } else {
      this.skipHelpTips();
    }
  }

  loadNewSchedule() {
    const renderWait = setInterval(() => {
      const elem = document.getElementsByClassName('cardPlaceholder');
        const elemPosition: ClientRect = elem[0].getBoundingClientRect();
          if ($('#coachmarkDetail').length === 1) {
            $('#coachmarkDetail').css('left', elemPosition.left - 5)
              .css('top', elemPosition.top + window.scrollY - 5)
              .css('display', 'flex');
          }
      clearInterval(renderWait);
    }, 500);
  }

  loadOnOff() {
      let elem = document.getElementsByClassName('card-onoff');
      if (elem.length < 1) {
        elem = document.getElementsByClassName('cardPlaceholderOnOff');
      }
        const elemPosition: ClientRect = elem[0].getBoundingClientRect();
        if ($('#coachmarkDetail').length === 1) {
          $('#coachmarkDetail').css('left', elemPosition.left - 10)
            .css('top', elemPosition.top + window.scrollY - 70)
            .css('display', 'flex');
        }
  }

  loadEconomic() {
    let elem = document.getElementsByClassName('card-eco');
    if (elem.length <= 1) {
      elem = document.getElementsByClassName('cardPlaceholderEco');
    }
      const elemPosition: ClientRect = elem[0].getBoundingClientRect();
      if ($('#coachmarkDetail').length === 1) {
        $('#coachmarkDetail').css('left', elemPosition.left - 10)
          .css('top', elemPosition.top + window.scrollY - 70)
          .css('display', 'flex');
      }
  }

  loadStandByKiller() {
    let elem = document.getElementsByClassName('card-standby');
    if (elem.length <= 1) {
      elem = document.getElementsByClassName('cardPlaceholderStandby');
    }
      const elemPosition: ClientRect = elem[0].getBoundingClientRect();
      if ($('#coachmarkDetail').length === 1) {
        $('#coachmarkDetail').css('left', elemPosition.left - 10)
          .css('top', elemPosition.top + window.scrollY - 70)
          .css('display', 'flex');
      }
  }

  loadScheduling() {
    let elem = document.getElementsByClassName('scheduleCard');
    if (elem.length <= 1) {
      elem = document.getElementsByClassName('cardPlaceholderAC');
    }
    const elemPosition: ClientRect = elem[0].getBoundingClientRect();
    if ($('#coachmarkDetailAC').length === 1) {
      $('#coachmarkDetailAC').css('left', elemPosition.left - 10)
        .css('top', elemPosition.top + window.scrollY - 65)
        .css('display', 'flex');
    }
  }

  getMsg() {
    switch (this.selectedTab) {
      case 1:
        return 'You can schedule working period of each <br> device with different types of schedules.';
      case 2:
      return 'Define the start and <br> the end of the schedule';
      case 3:
      if (!this.economicExcluded) {
        return 'Schedule the working period of your <br> devices according to your tariff';
      } else {
        return 'Control the consumption of the <br> devices in standby mode';
      }
      case 4:
      return 'Control the consumption of the <br> devices in standby mode';
    }
  }
  getImg() {
    switch (this.selectedTab) {
      case 1:
        return 'new-schedule';
      case 2:
      return 'new-schedule-on-off';
      case 3:
      if (!this.economicExcluded) {
        return 'new-schedule-economic';
      } else {
        return 'new-schedule-standby-killer';
      }
      case 4:
      return 'new-schedule-standby-killer';
    }
  }

  hasScheduling(): boolean {
    if (this.device === undefined) {
      return false;
    }
    const groups: Set<GROUP> = this.device.getGroups();
    return groups.has(GROUP.SWITCH) || groups.has(GROUP.THERMOSTAT);
  }

  isAC(): boolean {
    if (this.device === undefined) {
      return false;
    }
    const groups: Set<GROUP> = this.device.getGroups();
    return groups.has(GROUP.HVAC);
  }

  isThermo(): boolean {
    if (this.device === undefined) {
      return false;
    }
    const groups: Set<GROUP> = this.device.getGroups();
    return groups.has(GROUP.THERMOSTAT);
  }

  getACImg() {
    return '../assets/img/icons/new-schedule-setpoint.svg';
  }

  getACMsg() {
    // tslint:disable-next-line:max-line-length
    return 'You can schedule working period, <br> temperature and mode of AC device and <br> define which days of the week you want <br> the device to operate.';
  }

  gotIt() {
    this.show = false;
  }

  getBtnText() {
    if ((this.selectedTab === 3 && this.economicExcluded) || this.selectedTab ===  4) {
      return 'GOT IT!';
    } else {
      return 'NEXT!';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/coachmarks/coachmark-device-detail/coachmark-device-detail.component.ts